module.exports = __webpack_public_path__ + "static/media/02-video-class.ea3a1f85.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/how-courses-work/02-video-class.jpg
// module id = 371
// module chunks = 0